// @ts-nocheck
/* eslint-disable */
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  HIDE_FULLSCREEN_LOADER,
  SHOW_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { UPDATE_TAB_EDITED_STATE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';
import {
  ADD_CLAIM_ATTACHMENT_REQUEST,
  ADD_CLAIM_ATTACHMENT_SUCCESS,
  ADD_CLAIM_NOTE_REQUEST,
  ADD_CLAIM_NOTE_SUCCESS,
  ADD_CLAIM_REASON_REQUEST,
  ADD_CLAIM_REASON_SUCCESS,
  DELETE_CLAIM_ATTACHMENT_REQUEST,
  DELETE_CLAIM_ATTACHMENT_SUCCESS,
  DELETE_CLAIM_NOTE_REQUEST,
  DELETE_CLAIM_NOTE_SUCCESS,
  GET_CLAIM_ATTACHMENT_REQUEST,
  GET_CLAIM_ATTACHMENT_SUCCESS,
  GET_CLAIM_DETAILS_REQUEST,
  GET_CLAIM_DETAILS_SUCCESS,
  GET_CLAIM_HISTORY_REQUEST,
  GET_CLAIM_HISTORY_SUCCESS,
  GET_CLAIM_LIST_REQUEST,
  GET_CLAIM_LIST_SUCCESS,
  GET_CLAIM_REQUEST,
  GET_CLAIM_SUCCESS,
  GET_CLAIM_SUMMARY_REQUEST,
  GET_CLAIM_SUMMARY_SUCCESS,
  GET_CLAIM_TASK_LIST_REQUEST,
  GET_CLAIM_TASK_LIST_SUCCESS,
  GET_HIDE_TASK_REQUEST,
  GET_HIDE_TASK_SUCCESS,
  POST_CLAIM_REQUEST,
  POST_CLAIM_SUCCESS,
  POST_HIDE_TASK_REQUEST,
  POST_HIDE_TASK_SUCCESS,
  UPDATE_CLAIM_ATTACHMENT_REQUEST,
  UPDATE_CLAIM_ATTACHMENT_SUCCESS,
  UPDATE_CLAIM_NOTE_REQUEST,
  UPDATE_CLAIM_NOTE_SUCCESS,
  DELETE_CLAIM_REQUEST,
  DELETE_CLAIM_SUCCESS,
} from '../constants/claimConstants';
import { fetchPostApi } from 'utils/apiHelper';

function* getClaimListRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-get/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_LIST_SUCCESS, payload: data });
  }
}

function* getClaimTaskListRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/cost_claim/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_TASK_LIST_SUCCESS, payload: data });
  }
}

function* getClaimHistoryRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-history/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_HISTORY_SUCCESS, payload: data });
  }
}

function* getClaimSummaryRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-summary/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_SUMMARY_SUCCESS, payload: data });
  }
}

function* getClaimRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-post/${params.claim_id}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_SUCCESS, payload: data });
  }
}

function* getClaimDetailsRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-details/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_DETAILS_SUCCESS, payload: data });
  }
}

function* postClaimRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    payload.id ? services.fetchPutApi : services.fetchPostApi,
    payload.id
      ? `${API_URI}/claim-post/${payload.id}/`
      : `${API_URI}/claim-post/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: UPDATE_TAB_EDITED_STATE, payload: { tabEdited: false } });
    yield put({
      type: POST_CLAIM_SUCCESS,
    });
    successToast('Claim was added successfully.');
  }
}

function* addClaimNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.postFormData,
    `${API_URI}/claim-note/`,
    'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: ADD_CLAIM_NOTE_SUCCESS,
      payload: data,
    });
    successToast('Note was added successfully.');
  }
}

function* updateClaimNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.postFormData,
    `${API_URI}/claim-note/${payload.id}/`,
    'put',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: UPDATE_CLAIM_NOTE_SUCCESS,
      payload: data,
    });
    successToast('Note was updated successfully.');
  }
}

function* deleteClaimNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/claim-note/${payload[Object.keys(payload)[0]]}`,
    token,
  );
  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: DELETE_CLAIM_NOTE_SUCCESS,
      payload: payload,
    });
    successToast('Note was deleted successfully.');
  }
}

function* addClaimReasonRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/claim-note/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: ADD_CLAIM_REASON_SUCCESS,
      payload: data,
    });
    successToast('Reason was added successfully.');
  }
}

function* getClaimAttachmentRequest(action) {
  const token = localStorage.getItem('token');
  const { params } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim-attachment/?claim_id=${params.claim_id}`,
    token,
  );

  if (data) {
    yield put({ type: GET_CLAIM_ATTACHMENT_SUCCESS, payload: data });
  }
}

function* addClaimAttachmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/claim-attachment/`,
    'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: ADD_CLAIM_ATTACHMENT_SUCCESS,
      payload: data,
    });
    successToast('Attachment was added successfully.');
  }
}

function* updateClaimAttachmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/claim-attachment/${payload.id}/`,
    'put',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: UPDATE_CLAIM_ATTACHMENT_SUCCESS,
      payload: data,
    });
    successToast('Attachment was updated successfully.');
  }
}

function* deleteClaimAttachmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/claim-attachment/${payload}`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: DELETE_CLAIM_SUCCESS,
      payload,
    });
    successToast('Claim was deleted successfully.');
  }
}

function* getHideTaskService(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/hide-tasks/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_HIDE_TASK_SUCCESS, payload: data });
  }
}

function* postHideTaskService(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/hide-tasks/`,
    // 'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: POST_HIDE_TASK_SUCCESS,
      payload: data,
    });
  }
}
function* deleteClaimRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/claim-post/${payload}`,
    token,
  );

  if (data) {
    yield put({
      type: DELETE_CLAIM_SUCCESS,
      payload,
    });
    successToast('Claim was deleted successfully.');
  }
}

function* claimWatcher() {
  yield takeLatest(GET_CLAIM_LIST_REQUEST, getClaimListRequest);
  yield takeLatest(GET_HIDE_TASK_REQUEST, getHideTaskService);
  yield takeLatest(POST_HIDE_TASK_REQUEST, postHideTaskService);
  yield takeLatest(GET_CLAIM_TASK_LIST_REQUEST, getClaimTaskListRequest);
  yield takeLatest(GET_CLAIM_HISTORY_REQUEST, getClaimHistoryRequest);
  yield takeLatest(GET_CLAIM_SUMMARY_REQUEST, getClaimSummaryRequest);
  yield takeLatest(GET_CLAIM_REQUEST, getClaimRequest);
  yield takeLatest(GET_CLAIM_DETAILS_REQUEST, getClaimDetailsRequest);
  yield takeLatest(POST_CLAIM_REQUEST, postClaimRequest);
  yield takeLatest(ADD_CLAIM_NOTE_REQUEST, addClaimNoteRequest);
  yield takeLatest(DELETE_CLAIM_NOTE_REQUEST, deleteClaimNoteRequest);

  yield takeLatest(UPDATE_CLAIM_NOTE_REQUEST, updateClaimNoteRequest);

  yield takeLatest(ADD_CLAIM_REASON_REQUEST, addClaimReasonRequest);

  yield takeLatest(GET_CLAIM_ATTACHMENT_REQUEST, getClaimAttachmentRequest);

  yield takeLatest(ADD_CLAIM_ATTACHMENT_REQUEST, addClaimAttachmentRequest);
  yield takeLatest(
    UPDATE_CLAIM_ATTACHMENT_REQUEST,
    updateClaimAttachmentRequest,
  );
  yield takeLatest(
    DELETE_CLAIM_ATTACHMENT_REQUEST,
    deleteClaimAttachmentRequest,
  );
  yield takeLatest(DELETE_CLAIM_REQUEST, deleteClaimRequest);
}

export default claimWatcher;
